import AuthentifiedLayout from 'layout/AuthentifiedLayout';
import UnAuthentifiedLayout from 'layout/UnAuthentifiedLayout';

import { Navigate, Outlet } from 'react-router-dom';
import { LoginPage } from 'pages/AuthPages/LoginPage/LoginPage';
import { AdminView } from 'pages/Views/AdminView/AdminView';
import { UserView } from 'pages/Views/UserView/UserView';
import { Dashboard } from 'pages/DashboardPage/Dashboard';
import { Persons } from 'pages/PersonsPage/Persons';
import { MyFolder } from 'pages/UserPages/MyFolderPage/MyFolder';
import { MyRequests } from 'pages/UserPages/MyRequestsPage/MyRequests';
import { MyAppointments } from 'pages/UserPages/MyAppointmentsPage/MyAppointments';
import { NewAppointment } from 'pages/UserPages/NewAppointmentPage/NewAppointment';
import { NewPerson } from 'pages/NewPersonPage/NewPerson';
import { Statistics } from 'pages/StatisticsPage/Statistics';
import { SettingsPage } from 'pages/SettingsPage/SettingsPage';
import { PersonDetails } from 'pages/PersonDetailsPage/PersonDetails';
import { PersonProjectRequestForm } from 'pages/PersonDetailsPage/PersonDetailsFormsPages/PersonProjectRequestForm/PersonProjectRequestForm';
import { UserForm } from 'pages/SettingsPage/Users/UpdateUser/UserForm';
import { Partners } from 'pages/PartnersPage/Partners';
import { PartnerForm } from 'pages/Partners/PartnerForm';
import { PersonStakeholderForm } from 'pages/PersonDetailsPage/PersonDetailsFormsPages/PersonStakeHolderForm/PersonStakeholderForm';
import { ProjectEventForm } from 'pages/PersonDetailsPage/PersonDetailsFormsPages/PersonProjectEventForm/PersonProjectEventForm';
import { ForgotPassword } from 'pages/AuthPages/ForgotPasswordPage/ForgotPassword';
import { ResetPassword } from 'pages/AuthPages/ResetPasswordPage/ResetPassword';
import { PrivacyPolicy } from 'pages/PrivacyPolicyPage/PrivacyPolicy';
import { CalendarMobilePage } from 'pages/CalendarMobilePage/CalendarMobile';
import { CalendarPage } from 'pages/CalendarPage/Calendar';
import { PersonDetailsForm } from 'pages/PersonDetailsPage/PersonDetailsFormsPages/PersonDetailsForm/PersonDetailsForm';
import { AdminMobileView } from 'pages/Views/AdminMobileView/AdminMobileView';
import { isMobile } from 'react-device-detect';

export const routes = (isLogged: boolean | null | undefined, isPrivacyPolicyRead: boolean | null | undefined, userRole?: string) => {
    return [
        {
            path: '/',
            element: <Navigate to="/login" />
        },
        {
            path: 'login',
            element: !isLogged ? (
                <UnAuthentifiedLayout />
            ) : (
                <Navigate to={userRole === 'user' ? '/app/user' : isMobile ? '/mobile' : '/app/admin'} />
            ),
            children: [
                {
                    path: '',
                    element: <LoginPage />
                }
            ]
        },
        {
            path: 'forgot-password',
            element: !isLogged ? <UnAuthentifiedLayout /> : <Navigate to={userRole === 'user' ? '/app/user' : '/app/admin'} />,
            children: [
                {
                    path: '',
                    element: <ForgotPassword />
                }
            ]
        },
        {
            path: 'reset-password',
            element: !isLogged ? <UnAuthentifiedLayout /> : <Navigate to={userRole === 'user' ? '/app/user' : '/app/admin'} />,
            children: [
                {
                    path: '',
                    element: <ResetPassword />
                }
            ]
        },
        {
            path: 'privacy-policy',
            element: <UnAuthentifiedLayout />,
            children: [
                {
                    path: '',
                    element: <PrivacyPolicy />
                }
            ]
        },
        {
            path: 'app',
            element: isLogged ? isPrivacyPolicyRead ? <AuthentifiedLayout /> : <Navigate to="/privacy-policy" /> : <Navigate to="/login" />,
            children: [
                {
                    path: 'admin',
                    element: userRole !== 'user' ? <Outlet /> : <Navigate to="/app/user" />,
                    children: [
                        {
                            path: '',
                            element: <AdminView render={<Dashboard />} headerTitle="Tableau de bord" />
                        },
                        {
                            path: 'calendar',
                            element: <AdminView render={<CalendarPage />} headerTitle="Retour" backButton />
                        },
                        {
                            path: 'partners',
                            children: [
                                {
                                    path: '',
                                    element: <AdminView render={<Partners />} headerTitle="Partenaires" />
                                },
                                {
                                    path: 'new',
                                    element: <AdminView render={<PartnerForm />} headerTitle="Ajouter un partenaire" backButton />
                                },
                                {
                                    path: ':partnerId',
                                    element: <AdminView render={<PartnerForm />} headerTitle="Éditer un partenaire" backButton />
                                }
                            ]
                        },
                        {
                            path: 'persons',
                            children: [
                                {
                                    path: '',
                                    element: <AdminView render={<Persons />} headerTitle="Personnes soutenues" />
                                },
                                {
                                    path: 'new',
                                    element: <AdminView render={<NewPerson />} headerTitle="Soutenir une personne" backButton />
                                },
                                {
                                    path: ':personId',
                                    element: (
                                        <AdminView
                                            render={<PersonDetails />}
                                            backButtonLink={'/app/admin/persons'}
                                            headerTitle="Soutenir une personne"
                                            backButton
                                        />
                                    )
                                },
                                {
                                    path: ':personId/edit',
                                    element: (
                                        <AdminView
                                            render={<PersonDetailsForm />}
                                            headerTitle="Modification d'une personne soutenue"
                                            backButton
                                        />
                                    )
                                },
                                {
                                    path: ':personId/appointments',
                                    element: (
                                        <AdminView
                                            render={<PersonDetails />}
                                            backButtonLink={'/app/admin/persons'}
                                            headerTitle="Soutenir une personne"
                                            backButton
                                        />
                                    )
                                },
                                {
                                    path: ':personId/project/:projectId/requests/new',
                                    element: <AdminView render={<PersonProjectRequestForm />} headerTitle="Nouvelle demande" backButton />
                                },
                                {
                                    path: ':personId/project/:projectId/requests/:requestId/edit',
                                    element: (
                                        <AdminView
                                            render={<PersonProjectRequestForm />}
                                            headerTitle="Modification d'une demande"
                                            backButton
                                        />
                                    )
                                },
                                {
                                    path: ':personId/stakeholders',
                                    element: (
                                        <AdminView
                                            render={<PersonDetails />}
                                            backButtonLink={'/app/admin/persons'}
                                            headerTitle="Proches"
                                            backButton
                                        />
                                    ),
                                    children: []
                                },
                                {
                                    path: ':personId/stakeholders/new',
                                    element: (
                                        <AdminView render={<PersonStakeholderForm />} headerTitle="Ajout d'un nouveau proche" backButton />
                                    )
                                },
                                {
                                    path: ':personId/stakeholders/:stakeholderId/edit',
                                    element: (
                                        <AdminView render={<PersonStakeholderForm />} headerTitle="Modification d'un proche" backButton />
                                    )
                                },
                                {
                                    path: ':personId/project/:projectId/requests',
                                    element: (
                                        <AdminView
                                            render={<PersonDetails />}
                                            backButtonLink={'/app/admin/persons'}
                                            headerTitle="Liste des demandes"
                                            backButton
                                        />
                                    ),
                                    children: [
                                        {
                                            path: 'new',
                                            element: (
                                                <AdminView
                                                    render={<PersonProjectRequestForm />}
                                                    headerTitle="Nouvelle demande"
                                                    backButton
                                                />
                                            )
                                        }
                                    ]
                                },
                                {
                                    path: ':personId/project/:projectId/events',
                                    element: (
                                        <AdminView
                                            render={<PersonDetails />}
                                            backButtonLink={'/app/admin/persons'}
                                            headerTitle="Évolutions du projet"
                                            backButton
                                        />
                                    )
                                },
                                {
                                    path: ':personId/project/:projectId/events/new',
                                    element: <AdminView render={<ProjectEventForm />} headerTitle="Nouvel évènement" backButton />
                                },
                                {
                                    path: ':personId/project/:projectId/events/:eventId/edit',
                                    element: (
                                        <AdminView render={<ProjectEventForm />} headerTitle="Modification d'un évènement" backButton />
                                    )
                                }
                            ]
                        },
                        {
                            path: 'settings',
                            children: [
                                {
                                    path: '',
                                    element: <AdminView render={<SettingsPage />} headerTitle="Réglages" />
                                },
                                {
                                    path: 'users',
                                    children: [
                                        {
                                            path: 'add',
                                            element: (
                                                <AdminView
                                                    render={<UserForm mode="create" />}
                                                    headerTitle="Ajouter un utilisateur"
                                                    backButton
                                                />
                                            )
                                        },
                                        {
                                            path: ':userId',
                                            element: (
                                                <AdminView
                                                    render={<UserForm mode="update" />}
                                                    headerTitle="Modifier un utilisateur"
                                                    backButton
                                                />
                                            )
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            path: 'statistics',
                            element: <AdminView render={<Statistics />} headerTitle="Statistiques" />
                        }
                    ]
                },
                {
                    path: 'user',
                    element: userRole === 'user' ? <Outlet /> : <Navigate to="/app/admin" />,
                    children: [
                        { path: '', element: <UserView render={<MyFolder />} /> },
                        { path: 'requests', element: <UserView render={<MyRequests />} /> },
                        { path: 'appointments', element: <UserView render={<MyAppointments />} /> },
                        { path: 'new-appointment', element: <UserView render={<NewAppointment />} /> }
                    ]
                }
            ]
        },
        {
            path: 'mobile',
            element: isLogged ? <AuthentifiedLayout /> : <Navigate to="/login" />,
            children: [
                {
                    path: '',
                    element: userRole !== 'user' ? <Outlet /> : <Navigate to="/app/user" />,
                    children: [
                        {
                            path: '',
                            element: <AdminMobileView render={<CalendarMobilePage />} />
                        }
                    ]
                }
            ]
        }
    ];
};

export default routes;
